export default[
    {
        value: "Distribuicao",
        text: "Distribuição"
    },
    {
        value: "Geracao",
        text: "Geração"
    },
    {
        value: "Transmissao",
        text: "Transmissão"
    }    
]